const isDigitReg = /^.*[0-9]+.*/; // 是数字正则
const isLowerCaseReg = /^.*[a-z]+.*/; // 小写字母正则
const isUpperCaseReg = /^.*[A-Z]+.*/; // 大写字母正则
const specialCharacterReg = /^.*[^a-zA-Z0-9]+.*/; // 特殊字符正则

export function passwordValid(userName, pass) {
  if (pass == null || pass.length < 8 || pass.length > 20) {
    return '密码位数不对，长度最少8位，最大20位';
  } 
  
  // 记录匹配的次数
  var num = 0;
  if (isDigitReg.test(pass)) {
    num = num + 1;
  }

  if (isLowerCaseReg.test(pass)) {
    num = num + 1;
  }

  if (isUpperCaseReg.test(pass)) {
     num = num + 1;
  }

  if (specialCharacterReg.test(pass)) {
    num = num + 1;
  }

  if (num <= 2) {
    return '密码复杂度不足,\n(1)大写字母\n(2)小写字母\n(3)数字\n(4)特殊符号\n密码至少需包含上述情形中的三种';
  }

  if (pass.includes(userName)) {
    return '新密码不能包含用户名';
  }

  //密码中不能包含有连续四位及以上顺序(或逆序)数字(如：密码中不能包含1234或3210等)。
  var numberSequence = false;

  for (var i = 0; i < pass.length - 3; i++) {
    if (!isDigitReg.test(pass.substring(i, i + 1))
      || !isDigitReg.test(pass.substring(i + 1, i + 2) + "")
      || !isDigitReg.test(pass.substring(i + 2, i + 3) + "")
      || !isDigitReg.test(pass.substring(i + 3, i + 4) + "")) {
      continue;
    }

    var no1 = Number(pass.substring(i, i + 1));
    var no2 = Number(pass.substring(i + 1, i + 2));
    var no3 = Number(pass.substring(i + 2, i + 3));
    var no4 = Number(pass.substring(i + 3, i + 4));

    if (no1 + 1 == no2 && no2 + 1 == no3 && no3 + 1 == no4) {
      numberSequence = true;
      break;
    }

    if (no2 + 1 == no1 && no3 + 1 == no2 && no4 + 1 == no3) {
      numberSequence = true;
      break;
    }
  }

  if (numberSequence) {
    return '密码中不能包含有连续四位及以上顺序(或逆序)数字(如：密码中不能包含1234或3210等';
  }

  //密码中不能包含有连续四位及以上顺序(或逆序)字母，字母不区分大小写(如：密码中不能包含abcd或ABCD或AbcD或DcbA等)。

  var passLower = pass.toLocaleLowerCase();
  var letterSequence = false;

  for (var i = 0; i < passLower.length - 3; i++) {

      if (!isLowerCaseReg.test(passLower.substring(i, i + 1))
        || !isLowerCaseReg.test(passLower.substring(i + 1, i + 2) + "")
        || !isLowerCaseReg.test(passLower.substring(i + 2, i + 3) + "")
        || !isLowerCaseReg.test(passLower.substring(i + 3, i + 4) + "")) {
        continue;
      }

      var no1 = passLower.charAt(i).charCodeAt() + 0;
      var no2 = passLower.charAt(i + 1).charCodeAt() + 0;
      var no3 = passLower.charAt(i + 2).charCodeAt() + 0;
      var no4 = passLower.charAt(i + 3).charCodeAt() + 0;

      if (no1 + 1 == no2 && no2 + 1 == no3 && no3 + 1 == no4) {
        letterSequence = true;
        break;
      }

      if (no2 + 1 == no1 && no3 + 1 == no2 && no4 + 1 == no3) {
        letterSequence = true;
        break;
      }

  }

  if (letterSequence) {
    return '密码中不能包含有连续四位及以上顺序(或逆序)字母，字母不区分大小写(如：密码中不能包含abcd或ABCD或AbcD或AbcD或DcbA等';
  }

  //密码中不能包含有连续四位及以上重复字符，字母不区分大小写(如：密码中不能包含8888、aaaa 或AAAA或BbbB或 $$$$等四位及以上的重复字符)。

  var fourOrMoreSame = false;
  for (var i = 0; i < pass.length - 3; i++) {
    if ((passLower.charAt(i)) == passLower.charAt(i + 1)
      && passLower.charAt(i + 1) == passLower.charAt(i + 2)
      && passLower.charAt(i + 2) == passLower.charAt(i + 3)) {
      fourOrMoreSame = true;
    }
  }

  if (fourOrMoreSame) {
    return '密码中不能包含有连续四位及以上重复字符，字母不区分大小写(如：密码中不能包含8888、aaaa 或AAAA或BbbB或 $$$$等四位及以上的重复字符';
  }

  var cont = /^.*admin.*$/;
  var cont2 = /^.*pass.*$/;
  //禁忌词不区分大小写不能作为密码的一部分存在于密码中(如：admin, pass)。
  if (cont.test(passLower) || cont2.test(passLower)) {
    return '禁忌词不区分大小写不能作为密码的一部分存在于密码中(如：admin, pass)';
  }

  return true;
}

